import { useContext, useEffect, useState } from "react";
import Button from "../../../components/Button/Button";
import Menu from "../../../components/Menu/Menu";
import './Minigames.scss';
import useAuth from "../../../hooks/useAuth";
import NotAuthenticated from "../../../components/NotAuthenticated/NotAuthenticated";
import api from "../../../js/api";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../../js/UserContext";

export default function GameCodeSelector() {

    const [room, setRoom] = useState('');
    const { gameName } = useParams();
    const navigate = useNavigate();
    const { user, loading } = useContext(UserContext);

    const [game_data, setGame_data] = useState(null);

    useEffect(() => {
        if (!gameName) {
            return navigate('/misc/minigames', { replace: true });
        }

        api.get(`/games/` + gameName, { silent: true }).then((res) => {
            if (res && res.error) {
                return navigate('/misc/minigames', { replace: true });
            }

            setGame_data(res);
        }).catch((error) => {
            console.error('Error fetching game data:', error);
            navigate('/misc/minigames', { replace: true });
        });
    }, [])

    const authenticated = useAuth();
    if (authenticated === false) {
        return <NotAuthenticated />;
    }

    const loadGameData = () => {
        if (!game_data || loading) {
            return <p>Loading...</p>;
        }
        return (
            game_data ? (
                game_data && !game_data.error ? (
                    <div className='game-data'>
                        <h3>Game data</h3>
                        {
                            Object.keys(game_data).map((key, index) => (
                                game_data[key] ?
                                    <p key={index}><b>{key}</b>: {game_data[key]}</p>
                                    :
                                    ''
                            ))
                        }
                    </div>
                ) : (
                    <div className='game-data'>
                        <h3>Game data</h3>
                        <p>No game data found for user {user.login}</p>
                    </div>
                )
            ) : (
                <p>Loading...</p>
            )
        )
    }

    return (
        <div id='game-code-selector'>
            <div className='centered-container'>
                <h1 className='title'>{gameName.charAt(0).toUpperCase() + gameName.slice(1)}</h1>
                <Button text="Create Room" onClick={async (e) => {
                    if (!gameName) {
                        alert('Please select a game first');
                        return;
                    }

                    const current_rooms = await api.get(`/users/${user.login}/rooms`, { silent: true });
                    if (current_rooms.error) {
                        alert('Error fetching current rooms: ' + current_rooms.error);
                        navigate('/misc/minigames', { replace: true });
                        return;
                    }
                    if (current_rooms && current_rooms.length >= 3) {
                        alert('You can only create 3 rooms at a time. Please delete one of your existing rooms before creating a new one.');
                        return;
                    }

                    const name = prompt('Enter a name for the room:', '');
                    if (name === false || name === null)
                        return;
                    if (name.trim() === '') {
                        alert('Please enter a name for the room');
                        return;
                    }
                    const private_ = window.confirm('Is this room private? (yes/no)');
                    let password = null;
                    if (private_ === true)
                        password = prompt('Enter a password for the room:', '');
                    if (private_ && !password) {
                        alert('Please enter a password for the room');
                        return;
                    }
                    const r = await api.post(`/rooms`, {
                        game: gameName,
                        name: name,
                        is_private: private_ ? true : false,
                        password: password || null,
                    })
                    if (r.error)
                        return alert('Error creating room: ' + r.error);

                    alert(r.message || 'Room created successfully');
                    if (!r.room || !r.room.id) {
                        console.error('No room ID returned from server:', r);
                        return;
                    }
                    navigate('/misc/minigames/' + gameName + '/rooms/' + r.room.id);
                }} />
                <input type="number" className='game-code-selector-input' onChange={(e) => {
                    setRoom(e.target.value);
                }} />

                <Button text="Join Room" onClick={(e) => {
                    if (!room) {
                        alert('Please enter a room number');
                        return;
                    }
                    navigate('/misc/minigames/' + gameName + '/rooms/' + room);
                }} />

                <Button text="My Rooms" onClick={async (e) => {
                    navigate('/misc/minigames/' + gameName + '/rooms?login=' + user.login);
                }} />

                <Button text="View All Rooms" onClick={async (e) => {
                    navigate('/misc/minigames/' + gameName + '/rooms');
                }} />

                <br />
                <br />
                {loadGameData()}
                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    )
}